import axios from "axios";

const baseURL = import.meta.env.VITE_API_URL_JS;

export const GetDataBusiness = async (params) => {
    try {
        const response = await axios.get(`${baseURL}/get/all/m_business`, {
            params
        });
        return response.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export const GetDataBranch = async (params) => {
    try {
        const response = await axios.get(`${baseURL}/get/cabang`, {
            params
        });
        return response.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}

export const GetDataKPI = async (params) => {
    try {
        const response = await axios.get(`${baseURL}/get/data_kpi`, {
            params
        });
        return response.data;
    } catch (error) {
        console.log(error);
        return [];
    }
}